import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function CheeseCakesPage() {

    const heroData = [
        {
          title: "Cheesecakes",
          content: "Our cheesecakes are a dessert lover's dream. With velvety textures and rich flavors, each cheesecake is a decadent masterpiece topped with fruits, chocolates, or indulgent drizzles.",
          image: images.CheesecakeHeroImage, 
        },
      ];

    const productData = [
      {
        name: "Vanilla Cheesecake",
        content: "Creamy vanilla cheesecake on a graham cracker crust",
        price: 0,
        image: [
          images.Cheesecake1,
        ]
      },
      {
        name: "Red Velvet Cheesecake",
        content: "Light chocolate cheesecake with rich red color on a chocolate cookie crust",
        price: 0,
        image: [
          images.Cheesecake2,
        ]
      },
      {
        name: "Pistachio Chocolate Cheesecake",
        content: "Creamy cheesecake with pistachio and chocolate layers",
        price: 0,
        image: [
          images.Cheesecake1,
        ]
      },
      {
        name: "Raspberry Cheesecake",
        content: "Vanilla cheesecake with a raspberry swirl",
        price: 0,
        image: [
          images.Cheesecake2,
        ]
      },
      {
        name: "Chocolate Cheesecake",
        content: "Rich and creamy chocolate on a buttery crust",
        price: 0,
        image: [
          images.Cheesecake1,
        ]
      },
    ]

    const customerFavData = [
      {
        name1: "Red Velvet Cheesecake",
        image1: [
          images.Cheesecake2,
        ],
        content1: "Light chocolate cheesecake with rich red color on a chocolate cookie crust",
        name2: "Chocolate Cheesecake",
        image2: [
          images.Cheesecake1,
        ],
        content2: "Rich and creamy chocolate on a buttery crust"
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={productData} />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
